// store/authSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	showVerification: false,
	email: "",
	password: "",
	token: null,
	remember: false,
};

const authSlice = createSlice({
	name: "auth",
	initialState,
	reducers: {
		setLoginInfo: (state, action) => {
			const { email, password, token, remember } = action.payload;
			state.email = email;
			state.password = password;
			state.token = token;
			state.remember = remember;
			state.showVerification = true;
		},
		setShowVerification: (state, action) => {
			state.showVerification = action.payload;
		},
		setRemember: (state, action) => {
			state.remember = action.payload;
		},
		clearLoginInfo: (state) => {
			return initialState;
		},
	},
});

export const { setLoginInfo, clearLoginInfo, setShowVerification } = authSlice.actions;
export default authSlice.reducer;
